module.exports = __webpack_public_path__ + "img/v1.4.56a97ccf.jpg";